import React from 'react';
import { useTranslation } from 'react-i18next';

interface VariationControlsProps {
  ignorePattern: boolean;
  onIgnoreChange: (v: boolean) => void;
  variationDirection: string;
  onVariationChange: (v: string) => void;
}

/**
 * Shared "fugir do padrão" + "direção da variação" controls — used by the social AI
 * suggestions AND the blog content engine (instant + routine). Single source of truth.
 */
const VariationControls: React.FC<VariationControlsProps> = ({
  ignorePattern, onIgnoreChange, variationDirection, onVariationChange
}) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-3">
      <label className="flex items-start gap-3 cursor-pointer">
        <button
          type="button"
          onClick={() => onIgnoreChange(!ignorePattern)}
          aria-pressed={ignorePattern}
          className={`relative inline-flex h-6 w-11 flex-shrink-0 rounded-full transition-colors duration-200 mt-0.5 ${
            ignorePattern ? 'bg-primary-600' : 'bg-gray-300 dark:bg-gray-600'
          }`}
        >
          <span
            className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform duration-200 mt-0.5 ${
              ignorePattern ? 'translate-x-5' : 'translate-x-0.5'
            }`}
          />
        </button>
        <span className="min-w-0">
          <span className="block text-sm font-medium text-gray-900 dark:text-white">
            {t('social.variation.ignore', 'Fugir do padrão dos posts anteriores')}
          </span>
          <span className="block text-xs text-gray-500 dark:text-gray-400">
            {t('social.variation.ignoreHint', 'Ative para um conteúdo diferente do seu estilo habitual.')}
          </span>
        </span>
      </label>

      {ignorePattern && (
        <div>
          <label className="label">{t('social.variation.direction', 'Direção desta variação (opcional)')}</label>
          <textarea
            value={variationDirection}
            onChange={(e) => onVariationChange(e.target.value)}
            placeholder={t('social.variation.directionPlaceholder', 'Ex.: mais técnico; com mais humor; foco em cases')}
            className="input min-h-[72px] resize-y w-full"
          />
        </div>
      )}
    </div>
  );
};

export default VariationControls;
